import { MAX_ITEMS_PER_MIRRORED_DECLARATION } from '../constants';

// How many mirrored declarations a source with this many items is split into. Always at least one -
// even an empty source still produces a single mirrored declaration.
export const getMirroredDeclarationsCount = (
    itemCount: number,
    maxItemsPerDeclaration: number = MAX_ITEMS_PER_MIRRORED_DECLARATION
): number => {
    const requiredDeclarations = Math.ceil(itemCount / maxItemsPerDeclaration);
    const isValidCount = Number.isFinite(requiredDeclarations);

    return isValidCount ? Math.max(1, requiredDeclarations) : 1;
};
